"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalLoggerLevel = void 0;
const faro_web_sdk_1 = require("@grafana/faro-web-sdk");
Object.defineProperty(exports, "InternalLoggerLevel", { enumerable: true, get: function () { return faro_web_sdk_1.InternalLoggerLevel; } });
const faro_react_1 = require("@grafana/faro-react");
const faro_web_tracing_1 = require("@grafana/faro-web-tracing");
const IGNORE_URL_PATTERNS = [
    /^data:/gm,
    /.*bugsnag\.8x8\.com/gm,
    /.*walkme\.com/gm,
    /.*platform-ui-assets\.8x8\.com\/mfe_build_information/gm,
    /.*localhost/gm,
];
function initObservability(initObservabilityProps) {
    const { collectorUrl, apiKey, app, ignoreUrls = [], internalLoggerLevel = faro_web_sdk_1.InternalLoggerLevel.ERROR, paused = false, } = initObservabilityProps;
    if (window.puiFaro) {
        // eslint-disable-next-line no-console
        console.warn("Faro already initialized, returning the existing instance");
        return window.puiFaro;
    }
    return (0, faro_react_1.initializeFaro)({
        app,
        batching: {
            enabled: true,
            sendTimeout: 3000,
            itemLimit: 50,
        },
        // this skips the deduplication filter, sends all the errors/events/logs/measurements, even if they are repetitive
        // Individual api push dedupes can be skipped using `{ skipDedupe: true }`
        dedupe: false,
        // add the faro instance to window as window.puiFaro
        globalObjectKey: "puiFaro",
        instrumentations: [
            // ensure that initialization starts before the other instrumentations
            new faro_web_sdk_1.PerformanceInstrumentation(),
            // window.onerror and onunhandledrejection --> faro.api.pushError()
            new faro_web_sdk_1.ErrorsInstrumentation(),
            // Web Vitals detailed docs here: https://web.dev/articles/vitals
            // Uses https://www.npmjs.com/package/web-vitals under the hood
            new faro_web_sdk_1.WebVitalsInstrumentation(),
            new faro_web_sdk_1.SessionInstrumentation(),
            new faro_web_sdk_1.ViewInstrumentation(),
            // OpenTelemetry tracing instrumentation from Faro
            new faro_web_tracing_1.TracingInstrumentation({
                instrumentations: [
                    ...(0, faro_web_tracing_1.getDefaultOTELInstrumentations)({
                        ignoreUrls: [...IGNORE_URL_PATTERNS, ...ignoreUrls, collectorUrl],
                        // add Tracing instrumentation ("Traceparent" header: 00-[trace_id]-[span_id]-01) to CORS requests to *.8x8.com domains
                        propagateTraceHeaderCorsUrls: [/.*8x8\.com/gm],
                    }),
                ],
                // instrumentationOptions: {
                //   // add Tracing instrumentation ("Traceparent" header: 00-[trace_id]-[span_id]-01) to CORS requests to *.8x8.com domains
                //   propagateTraceHeaderCorsUrls: [/.*8x8\.com/gm],
                // },
            }),
            new faro_react_1.ReactIntegration(),
        ],
        internalLoggerLevel,
        // allow Faro work in isolation, required by the MFE architecture
        // need to monitor the capabilities since it is at a PoC level (+ missing documentation)
        isolate: false,
        url: collectorUrl,
        apiKey: apiKey,
        ignoreUrls: [...IGNORE_URL_PATTERNS, ...ignoreUrls, collectorUrl],
        paused,
        sessionTracking: {
            enabled: true,
            // sessionId stored in local storage, issue may happen if multipe users are using the same browser
            persistent: false,
            maxSessionPersistenceTime: 5 * 60 * 1000,
            samplingRate: 1,
            // generateSessionId - to include the user ID in session ID and check if it is different -> invalidate
            // on logout: import { PersistentSessionsManager } from '@grafana/faro-web-sdk'; PersistentSessionsManager.removeUserSession();
        },
        view: {
            name: "Default view",
        },
        // Default event domain (can be overwritten with 3rd parameter of `faro.api.pushEvent`)
        eventDomain: "8x8 web application",
        trackResources: false,
    });
}
exports.default = initObservability;
//# sourceMappingURL=initObservability.js.map